export const TYPES = {
  LOCATION_UPDATED: 'LOCATION_UPDATED',
  HASH_UPDATED: 'HASH_UPDATED',
};

export const routeLocationDidUpdate = location => ({
  type: TYPES.LOCATION_UPDATED,
  location,
});

export const routeHashDidUpdate = location => ({
  type: TYPES.HASH_UPDATED,
  location,
});



/** WEBPACK FOOTER **
 ** ./src/redux/actions/locationActions.js
 **/